import { css } from 'emotion';
import { enableLogoLink } from 'config/system';
import logoImage from 'images/cis/logo.png';

export const logo = css(`
	:lang(ar){
		transform: scaleX(-1);
		direction: rtl;
	}
	display: inline-block;
	user-select: ${enableLogoLink ? 'auto' : 'none'};
	width: 90px;
	height: 90px;
	background-image: url('${logoImage}');
	background-position: 0 -90px;
	background-size: 100% auto;
	vertical-align: middle;
`);
